import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import { GoArrowLeft, GoArrowRight } from "react-icons/go";
import { AiFillStar, AiOutlineStar } from 'react-icons/ai';


import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import './main.css';
import { Link } from 'react-router-dom';
import Photo from '../components/Photo';

const Main = () => {
  const imageBaseUrl = "/templates/";
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 435);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 435);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [apiUrl, setApiUrl] = useState('');
  const [mainReviews, setMainReviews] = useState([]);
  const [mainLoadingApiUrl, setMainLoadingApiUrl] = useState(true);
  const [mainLoadingReviews, setMainLoadingReviews] = useState(false);
  const [mainError, setMainError] = useState('');

  
  useEffect(() => {
    const fetchApiUrl = async () => {
      try {
        const response = await axios.get('/templates/api.txt');
        const url = response.data.trim();
        setApiUrl(url);
      } catch (err) {
        console.error('Ошибка при загрузке API URL:', err);
        setMainError('Не удалось загрузить конфигурацию API.');
      } finally {
        setMainLoadingApiUrl(false);
      }
    };
    fetchApiUrl();
  }, []);

  
  useEffect(() => {
    if (!apiUrl) return;
    const fetchMainReviews = async () => {
      setMainLoadingReviews(true);
      setMainError('');
      try {
        const response = await axios.get(`${apiUrl}api/reviews`, {
          params: {
            per_page: 6,
            page: 1,
            sort: 'latest', 
          },
        });
        setMainReviews(response.data.reviews);
      } catch (err) {
        console.error('Ошибка при загрузке отзывов:', err);
        setMainError('Не удалось загрузить отзывы.');
      } finally {
        setMainLoadingReviews(false);
      }
    };
    fetchMainReviews();
  }, [apiUrl]);

  
  const cards = [
    { image: 'malbro.webp', text: 'Бестселлер' },
    { image: 'itera.webp', text: 'Новинки' },
    { image: 'philip.webp', text: 'Топ 25' },
  ];

  const mainReviewsPrevRef = useRef(null);
  const mainReviewsNextRef = useRef(null);

  const months = [
    'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
    'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
  ];

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    if (isNaN(date)) return 'Неверная дата';
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  const bannerImages = [
    isMobile ? 'Sig_Ban_1_M.webp' : 'Sig_Ban_1.webp',
    isMobile ? 'Sig_Ban_2_B_Min.webp' : 'Sig_Ban_2_B.webp',
    isMobile ? 'Sig_Ban_3_Min.webp' : 'Sig_Ban_3.webp',
    isMobile ? 'Sig_Ban_4_Min.webp' : 'Sig_Ban_4.webp',
  ];

  const getAvatarColor = (name) => {
    if (!name) return '#4e4d4d';
    const colors = [
      '#1abc9c', '#2ecc71', '#3498db', '#9b59b6',
      '#34495e', '#16a085', '#27ae60', '#2980b9',
      '#8e44ad', '#2c3e50', '#f1c40f', '#e67e22',
      '#e74c3c', '#ecf0f1', '#95a5a6', '#f39c12',
      '#d35400', '#c0392b', '#bdc3c7', '#7f8c8d'
    ];
    const char = name.charAt(0).toUpperCase();
    const index = char.charCodeAt(0) - 65;
    if (index >= 0 && index < 26) {
      return colors[index % colors.length];
    }
    return '#4e4d4d';
  };

  return (
    <div className="main-content">
      <Helmet>
        <meta
          name="description"
          content="Главная страница магазина Nicotine Club – лучшие сигареты, табачные изделия и аксессуары. Подберите идеальные сигареты для себя."
        />
        <meta
          name="keywords"
          content="купить сигареты, сигареты оптом, табачные изделия, купить табак, сигареты дешево, Nicotine Club, магазин сигарет, табак для кальяна, сигареты с доставкой"
        />
      </Helmet>

      {/* Слайдер баннеров */}
      <div className="swiper-container banners-swiper-container">
        <Swiper
          slidesPerView={1}
          loop={true}
          pagination={{ clickable: true }}
          navigation={false}
          modules={[Pagination]}
          className="bannersSwiper"
        >
          {bannerImages.map((src, index) => (
            <SwiperSlide key={index}>
              <Photo
                src={src}
                alt={`Слайд ${index + 1}`}
                className="slide-image"
                apiUrl={imageBaseUrl}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Карточки */}
      <div className="additional-content">
        <h2 className="additional-title">Сигареты</h2>
        <div className="cards-main-container">
          {cards.map((card, index) => (
            <Link
              to={`/catalog?filters=${encodeURIComponent(card.text)}`}
              key={index}
              className="card-link"
            >
              <div className="card-main">
                <div className="card-image-container">
                  <Photo
                    src={card.image}
                    alt={`Карточка ${index + 1}`}
                    className="card-image"
                    apiUrl={imageBaseUrl}
                  />
                </div>
                <div className="card-text">{card.text}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Блок "Подобрать сигареты" */}
      <div className="scent-block">
        <div className="scent-text">
          Подобрать сигареты по вкусу, по крепости, под напиток<br />
          <span className="highlight-text">или настроение</span>
        </div>
        <Link to="/catalog" className="scent-button">
          Подобрать сигареты
        </Link>
      </div>

      {/* Отзывы */}
      <div className="main-reviews-block">
        <h2 className="main-reviews-title">Отзывы и рейтинги</h2>
        <button ref={mainReviewsPrevRef} className="main-reviews-prev">
          <GoArrowLeft />
        </button>
        <button ref={mainReviewsNextRef} className="main-reviews-next">
          <GoArrowRight />
        </button>

        <Swiper
          slidesPerView={1}
          loop={true}
          pagination={{ clickable: true }}
          navigation={{
            prevEl: mainReviewsPrevRef.current,
            nextEl: mainReviewsNextRef.current,
          }}
          modules={[Pagination, Navigation]}
          className="main-reviewsSwiper"
          onSwiper={(swiper) => {
            swiper.params.navigation.prevEl = mainReviewsPrevRef.current;
            swiper.params.navigation.nextEl = mainReviewsNextRef.current;
            swiper.navigation.destroy();
            swiper.navigation.init();
            swiper.navigation.update();
          }}
          breakpoints={{
            1200: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
            768: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
          }}
        >
          {mainReviews.map((review, index) => (
            <SwiperSlide key={index}>
              <div className="main-review-comment">
                <div className="main-review-header">
                  <div className="main-review-user">
                    <div
                      className="main-avatar-placeholder"
                      style={{ backgroundColor: getAvatarColor(review.name) }}
                    >
                      {review.name ? review.name.charAt(0).toUpperCase() : 'A'}
                    </div>
                    <span className="main-author-name">
                      {review.name || 'Неизвестный'}
                    </span>
                  </div>
                  <div className="main-review-stars-date">
                    <div className="main-stars">
                      {[...Array(5)].map((_, starIndex) =>
                        starIndex < (review.stars || 3) ? (
                          <AiFillStar key={starIndex} color="#000000" size={14} />
                        ) : (
                          <AiOutlineStar key={starIndex} color="#000000" size={14} />
                        )
                      )}
                    </div>
                    <span className="main-review-date">
                      {review.dateStr ? formatDate(review.dateStr) : 'Неизвестная дата'}
                    </span>
                  </div>
                </div>
                <p className="main-review-text">
                  {review.comment || 'Комментарий отсутствует.'}
                </p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="main-ratings-container">
          <div className="main-rating-item">
            <Photo
              src="yandex-logo.png"
              alt="Яндекс"
              className="main-rating-logo"
              apiUrl={imageBaseUrl}
            />
            <div className="main-rating-stars">
              {[...Array(5)].map((_, starIndex) => (
                <AiFillStar key={starIndex} color="#000000" size={16} />
              ))}
            </div>
          </div>
          <div className="main-rating-item">
            <Photo
              src="2gis-logo.png"
              alt="2Gis"
              className="main-rating-logo"
              apiUrl={imageBaseUrl}
            />
            <div className="main-rating-stars">
              {[...Array(5)].map((_, starIndex) => (
                <AiFillStar key={starIndex} color="#000000" size={16} />
              ))}
            </div>
          </div>
          <div className="main-rating-item">
            <Photo
              src="zoon-logo.png"
              alt="Zoon"
              className="main-rating-logo"
              apiUrl={imageBaseUrl}
            />
            <div className="main-rating-stars">
              {[...Array(5)].map((_, starIndex) => (
                <AiFillStar key={starIndex} color="#000000" size={16} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
